import { bulletTypeKeys, bulletTypes } from "~defs/BulletTypeDefs";
import { UpdateType } from "../../../backend/src/lib/types";
import { Engine } from "./Engine";
import { InputDirection, Player } from "./Player";

export class LocalInterface {
  engine: Engine;
  constructor(engine: Engine) {
    this.engine = engine;
    window.addEventListener(
      "keydown",
      ((e: KeyboardEvent) => {
        if (document.activeElement?.className === "ignoreKeyEvents") return;
        if (!this.engine.remote.ready) return;
        this.keyDown(e);
      }).bind(this)
    );
    window.addEventListener(
      "keyup",
      ((e: KeyboardEvent) => {
        if (document.activeElement?.className === "ignoreKeyEvents") return;
        if (!this.engine.remote.ready) return;
        this.keyUp(e);
      }).bind(this)
    );
  }

  private sendUpdate() {
    const player = this.engine.getLocalPlayer();
    this.engine.remote.sendUpdate({
      type: UpdateType.PLAYER_UPDATE,
      pid: player.id,
      x: player.x,
      vx: player.vx,
      dir: player.direction,
      angle: player.angle,
      angleDir: player.angleDirection,
      tick: this.engine.tick,
    });
  }

  private setPlayerDirection(direction: InputDirection) {
    this.engine.getLocalPlayer().direction = direction;
    this.sendUpdate();
  }

  private setPlayerAngle(direction: InputDirection) {
    this.engine.getLocalPlayer().angleDirection = direction;
    this.sendUpdate();
  }

  private setPlayerPower(direction: InputDirection) {
    const player = this.engine.getLocalPlayer();
    player.powerDirection = direction;
  }

  private setPlayerFiring(state: boolean) {
    const player = this.engine.getLocalPlayer();
    player.firing = state;
  }

  keyDown(e: KeyboardEvent) {
    const player = this.engine.getLocalPlayer();
    switch (e.code) {
      case "KeyD":
        if (player.direction != InputDirection.POSITIVE)
          this.setPlayerDirection(InputDirection.POSITIVE);
        break;
      case "KeyA":
        if (player.direction != InputDirection.NEGATIVE)
          this.setPlayerDirection(InputDirection.NEGATIVE);
        break;
      case "KeyE":
        if (player.angleDirection != InputDirection.POSITIVE)
          this.setPlayerAngle(InputDirection.POSITIVE);
        break;
      case "KeyQ":
        if (player.angleDirection != InputDirection.NEGATIVE)
          this.setPlayerAngle(InputDirection.NEGATIVE);
        break;
      case "KeyW":
        if (player.powerDirection != InputDirection.POSITIVE)
          this.setPlayerPower(InputDirection.POSITIVE);
        break;
      case "KeyS":
        if (player.powerDirection != InputDirection.NEGATIVE)
          this.setPlayerPower(InputDirection.NEGATIVE);
        break;
      case "KeyZ":
        if (player.weaponType.id === bulletTypeKeys[0]) {
          player.weaponType = bulletTypes[bulletTypeKeys.slice(-1)[0]];
        } else {
          player.weaponType =
            bulletTypes[
              bulletTypeKeys[bulletTypeKeys.indexOf(player.weaponType.id) - 1]
            ];
        }
        break;
      case "KeyX":
        if (player.weaponType.id === bulletTypeKeys.slice(-1)[0]) {
          player.weaponType = bulletTypes[bulletTypeKeys[0]];
        } else {
          player.weaponType =
            bulletTypes[
              bulletTypeKeys[bulletTypeKeys.indexOf(player.weaponType.id) + 1]
            ];
        }
        break;
      case "Space":
        this.setPlayerFiring(true);
        break;
    }
  }

  keyUp(e: KeyboardEvent) {
    const player = this.engine.getLocalPlayer();
    switch (e.code) {
      case "KeyD":
        if (player.direction == InputDirection.POSITIVE)
          this.setPlayerDirection(InputDirection.NONE);
        break;
      case "KeyA":
        if (player.direction == InputDirection.NEGATIVE)
          this.setPlayerDirection(InputDirection.NONE);
        break;
      case "KeyE":
        if (player.angleDirection == InputDirection.POSITIVE)
          this.setPlayerAngle(InputDirection.NONE);
        break;
      case "KeyQ":
        if (player.angleDirection == InputDirection.NEGATIVE)
          this.setPlayerAngle(InputDirection.NONE);
        break;
      case "KeyW":
        if (player.powerDirection == InputDirection.POSITIVE)
          this.setPlayerPower(InputDirection.NONE);
        break;
      case "KeyS":
        if (player.powerDirection == InputDirection.NEGATIVE)
          this.setPlayerPower(InputDirection.NONE);
        break;
      case "Space":
        this.setPlayerFiring(false);
        break;
    }
  }
}
